<ag-grid-angular style="width: 100%; top:1%;margin-bottom: 5%;" class="ag-theme-balham"
    [rowData]="rowData" [columnDefs]="columnDefs" [rowSelection]="rowSelection" [gridOptions]="gridOptions"
    [pagination]="pagination" [paginationPageSize]="paginationPageSize" [context]="context" [editType]="editType"
    [pagination]="true" [suppressClickEdit]="suppressClickEdit" (gridReady)="onGridReady($event)"
    [paginationNumberFormatter]="paginationNumberFormatter" [frameworkComponents]="frameworkComponents"
    [tooltipShowDelay]="tooltipShowDelay" [tooltipMouseTrack]="true" >
</ag-grid-angular>
<!-- height:400px; -->
